import TableCampaignRows from './TableCampaignRows'

export default TableCampaignRows
